<template>
  <div class='page-wrap' :class='device=="mobile"?"mobile":""'>
    <nav-bar></nav-bar>
    <div class="app-container" v-loading='pageLoading'>
      <div class='theader'>
        <p>地址详情</p>
      </div>
      <div class="page-sec">
        <template v-if='tradeObj.total && assetsObj.total'>
          <div class='content-sec'>
            <div class="common-row"><span class='key'>钱包地址：</span><span class='value'>{{ walletAddr }}</span><span class="copy-btn" :data-clipboard-text="walletAddr" @click='copyFn'></span></div>
            <div class="common-row"><span class='key'>交易数量：</span><span class='value'>{{ tradeObj.total }}</span></div>
            <div class="common-row"><span class='key'>资产数量：</span><span class='value'>{{ assetsObj.total }}</span></div>
          </div>
        </template>
        <el-row v-else type='flex' justify="center" style='width: 100%;'>
          <el-empty :image-size="100" description="暂未找到您所查询的内容，请重新查询"></el-empty>
        </el-row>
      </div>
      
      <div class='theader'>
        <el-tabs v-model="activeName" @tab-click="">
          <el-tab-pane label="资产信息" name="first"></el-tab-pane>
          <el-tab-pane label="交易信息" name="second"></el-tab-pane>
        </el-tabs>
      </div>
      
      <template v-if='activeName=="second"'>
        <template v-if='tradeObj.list && tradeObj.list.length>0'>
          <!-- 表格 -->
          <el-table
            ref='tradeTable'
            key="tradeTable"
            v-loading="pageLoading"
            :data="tradeObj.list"
            fit
            highlight-current-row
            :size='device=="mobile"?"mini":""'
            style="width: 100%;"
          >
            <!-- <el-table-column label="ID" align="center" width="80">
              <template slot-scope="scope">
                <span>{{ scope.row.id }}</span>
              </template>
            </el-table-column> -->
            <el-table-column label="交易哈希" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class='link-type' @click='$router.push({ name: "trade", query: { key: scope.row.transactioHash } })'>{{ scope.row.transactioHash }}</span>
              </template>
            </el-table-column>
            <el-table-column label="发送账户" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class=''>{{ scope.row.fromAddress}}</span>
              </template>
            </el-table-column>
            <el-table-column label="接收账户" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class='link-type' @click='$router.push({ name: "address", query: { key: scope.row.toAddress  } })'>{{ scope.row.toAddress }}</span>
              </template>
            </el-table-column>
            <el-table-column label="主资产编号" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="">{{ scope.row.mainId }}</span>
              </template>
            </el-table-column>
            <el-table-column label="子资产编号" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="">{{ scope.row.subId }}</span>
              </template>
            </el-table-column>
            <el-table-column label="交易订单号" align="center" width="160">
              <template slot-scope="scope">
                <span class="">{{ scope.row.transactionOrderId }}</span>
              </template>
            </el-table-column>
            <el-table-column label="交易时间" align="center" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.transactionTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="交易状态" align="center" width="100">
              <template slot-scope="scope">
                <span :class='scope.row.transactioState===0?"text-gray":scope.row.transactioState===1?"text-green":""'>{{ scope.row.transactioState===0?"等待确认":scope.row.transactioState===1?"交易成功":"" }}</span>
              </template>
            </el-table-column>
          </el-table>
          
          <!-- 分页 -->
          <div class="pagination-container">
            <el-pagination v-if='device!="mobile"' v-show="tradeObj.total>0" :current-page="Math.floor(tradeObj.listQuery.skipCount/tradeObj.listQuery.maxResultCount)+1" :page-sizes="[10,15,30, 50]" :page-size="tradeObj.listQuery.maxResultCount" :total="tradeObj.total" background layout="total, sizes, prev, pager, next, jumper" @size-change="(val) => handleSizeChange('trade', val)" @current-change="(val) => handleCurrentChange('trade', val)"/>
            <el-pagination
              v-else
              small
              layout="prev, pager, next"
              :total="assetsObj.total"
              @current-change="(val) => handleCurrentChange('trade', val)">
            </el-pagination>
          </div>
        </template>
        <div v-else class="page-sec">
          <el-row type='flex' justify="center" style='width: 100%;'>
            <el-empty :image-size="100" description="暂未找到您所查询的内容，请重新查询"></el-empty>
          </el-row>
        </div>
      </template>
      
      <template v-else>
        <template v-if='assetsObj.list && assetsObj.list.length>0'>
          <el-table
            ref='assetsTable'
            key="assetsTable"
            v-loading="pageLoading"
            :data="assetsObj.list"
            fit
            highlight-current-row
            :size='device=="mobile"?"mini":""'
            style="width: 100%;"
          >
            <!-- <el-table-column label="ID" align="center" width="80">
              <template slot-scope="scope">
                <span>{{ scope.row.id }}</span>
              </template>
            </el-table-column> -->
            <el-table-column label="主资产编号" align="center" min-width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class='link-type' @click='$router.push({ name: "assets", query: { key: scope.row.mainId }  })'>{{ scope.row.mainId }}</span>
              </template>
            </el-table-column>
            <el-table-column label="子资产编号" align="center" min-width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="">{{ scope.row.subId }}</span>
              </template>
            </el-table-column>
            <el-table-column label="发行账户" align="center" min-width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class='link-type' @click='$router.push({ name: "address", query: { key: scope.row.assetAddr  } })'>{{ scope.row.assetAddr }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="作品名称" align="center" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.assetAddr }}</span>
              </template>
            </el-table-column> -->
            <el-table-column label="作者名称" align="center" min-width="150" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>
                  <el-tag
                    class='tag'
                    v-for="item in scope.row.authorNames"
                    :key="item"
                    type="info"
                    effect="dark"
                    style='margin: 3px;'>
                    {{ item }}
                  </el-tag>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="获得时间" align="center" width="170">
              <template slot-scope="scope">
                <span>{{ scope.row.releaseTime }}</span>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="pagination-container">
            <el-pagination v-if='device!="mobile"' v-show="assetsObj.total>0" :current-page="Math.floor(assetsObj.listQuery.skipCount/assetsObj.listQuery.maxResultCount)+1" :page-sizes="[10,15,30, 50]" :page-size="assetsObj.listQuery.maxResultCount" :total="assetsObj.total" background layout="total, sizes, prev, pager, next, jumper" @size-change="(val) => handleSizeChange('assets', val)" @current-change="(val) => handleCurrentChange('assets', val)"/>
            <el-pagination
              v-else
              small
              layout="prev, pager, next"
              :total="assetsObj.total"
              @current-change="(val) => handleCurrentChange('assets', val)">
            </el-pagination>
          </div>
        </template>
        <div v-else class="page-sec">
          <el-row type='flex' justify="center" style='width: 100%;'>
            <el-empty :image-size="100" description="暂未找到您所查询的内容，请重新查询"></el-empty>
          </el-row>
        </div>
      </template>

    </div>
  </div>
</template>

<script>
import { assetsTable, tradeTable, addr } from '@/api/address'
import { Mixin } from '@/utils/mixin.js'; 
import { mapGetters } from 'vuex'

export default {
  name: 'manage',
  mixins: [ Mixin ],
  data() {
    return {
      // zpZMdD2rF7Aw5x5isfaA4w6gEfyeKEpZ1E
      walletAddr: this.$route.query.key || '',
      activeName: 'first',
      assetsObj: {
        list: null,
        total: null,
        listQuery: {
          maxResultCount: 10,
          skipCount: 0,
          walletAddr: '',
        },
      },
      tradeObj: {
        list: null,
        total: null,
        listQuery: {
          maxResultCount: 10,
          skipCount: 0,
          walletAddr: '',
        },
      },
      pageLoading: false,
      freshLoading: false,
      downLoading: false,
    }
  },
  computed: {
    ...mapGetters([
      'cacheData'
    ]),
  },
  created() {
    if(this.cacheData) {
      this.assetsTableReqCb(this.cacheData)
      this.tradeTableReq()
      this.$store.dispatch('app/cacheData', null)
      return;
    }
    this.fetchList()
  },
  mounted() {
    
  },
  methods: {
    fetchList() {
      this.pageLoading = true
      Promise.all([
        assetsTable(Object.assign({}, this.assetsObj.listQuery, { walletAddr: this.walletAddr })),
        tradeTable(Object.assign({}, this.tradeObj.listQuery, { walletAddr: this.walletAddr }))
      ]).then(responses => {
        this.assetsTableReqCb(responses[0].data)
        this.tradeTableReqCb(responses[1].data)
        this.pageLoading = false
      }).catch(() => {
        this.pageLoading = false
      })
    },
    assetsTableReq() {
      this.pageLoading = true
       assetsTable(Object.assign({}, this.assetsObj.listQuery, { walletAddr: this.walletAddr })).then(response => {
        this.assetsTableReqCb(response.data)
        this.pageLoading = false
      }).catch(() => {
        this.pageLoading = false
      })
    },
    assetsTableReqCb(data) {
      if(!data) return;
      let { items: assetsItems, totalCount: assetsTotalCount } = data
      this.assetsObj.list = assetsItems
      this.assetsObj.total = assetsTotalCount
      this.$nextTick(()=>{
        // this.$refs.assetsTable.doLayout()
      })
    },

    tradeTableReq() {
      this.pageLoading = true
       tradeTable(Object.assign({}, this.tradeObj.listQuery, { walletAddr: this.walletAddr })).then(response => {
        this.tradeTableReqCb(response.data)
        this.pageLoading = false
      }).catch(() => {
        this.pageLoading = false
      })
    },
    tradeTableReqCb(data) {
      if(!data) return;
      let { items: tradeItems, totalCount: tradeTotalCount } = data
      this.tradeObj.list = tradeItems
      this.tradeObj.total = tradeTotalCount
      this.$nextTick(()=>{
        // this.$refs.tradeTable.doLayout()
      })
    },
    handleSizeChange(type, val) {
      this[type + 'Obj'].listQuery.skipCount = 0
      this[type + 'Obj'].listQuery.maxResultCount = val
      this[type + 'TableReq']()
    },
    handleCurrentChange(type, val) {
      console.log(val)
      console.log((val-1) * this[type + 'Obj'].listQuery.maxResultCount)

      this[type + 'Obj'].listQuery.skipCount = (val-1) * this[type + 'Obj'].listQuery.maxResultCount
      this[type + 'TableReq']()
    },
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  ::v-deep .el-tabs {
    .el-tabs__header {
      margin: 0;
    }
    .el-tabs__item {
      height: 40px;
      line-height: 40px;
      font-size: 20px;
    }
    .el-tabs__active-bar {
      height: 3px;
    }
    .el-tabs__nav-wrap::after {
      width: 0;
    }
  }

  .mobile ::v-deep .el-tabs {
    .el-tabs__item {
      height: 28px;
      line-height: 28px;
      font-size: 15px;
      padding: 0 10px;
      color: #333; 
    }
    .el-tabs__active-bar {
      height: 2px;
    }
  }

</style>
